module.exports = __webpack_public_path__ + "img/poster-2-sm.c6a0fefe.png";